'use client'
import { AiOutlineArrowRight } from 'react-icons/ai'
import { FiArrowUpRight } from 'react-icons/fi'
import Partner from './Partner'
// import Modal from '@/components/modal'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'

import { buttonVariantsPartner } from '@/components/ui/button'
import { getApplyRedirectUrl } from '@/lib/utils/functions'
import { cn } from '@/lib/utils/helpers'
import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import Link from 'next/link'
import MentorMatchingCard from '../aichat/ChatPage'
import { PoweredBy } from './PoweredBy'

const DriveChange = () => {
  const { session } = useAuth()

  return (
    <main className="flex flex-col align-center gap-4  bg-inherit">
      <HeroSection session={session} />
      <main>
        <div className="relative bg-[#000] py-14">
          <div className="mb-[10%]">
            <CollaborationOpportunities isPartner={true} />
          </div>
          <div className="mb-[10%] px-6 sm:px-0">
            <MentorMatchingCard
              videoUrl={' https://youtu.be/kczTopDzvA0'}
              bg={'/images/home/mentors/mentorVideoBg.webp'}
              title={'Demo Day 1'}
            />
          </div>

          <FadeInStagger faster className="mb-[10%]">
            <BenefitsOfCollaboration />
          </FadeInStagger>

          <div className="mb-[4%]">
            <Partner />
          </div>
        </div>
      </main>
    </main>
  )
}

export default DriveChange

const img = 'url("/images/home/BACKGROUNDOVERLAY.webp")'
const HeroSection = ({ session }) => {
  return (
    <section
      className="sm:bg-[top] sm:bg-[center_left_0rem]  relative bg-cover bg-center text-white flex justify-start items-center"
      style={{
        backgroundImage: img,
        // backgroundPosition: 'center left 00px',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="relative z-10 mx-auto  px-6 sm:px-0 pb-10  portrait:pt-20 lg:landscape:pt-4  overflow-hidden sm:pt-[20px]">
        <FadeInStagger faster className="mx-auto max-w-7xl px-2 sm:px-6 pb-10">
          <FadeIn className="flex portrait:mt-[0px] lg:landscape:mt-[80px] ">
            <div className="bg-white bg-opacity-5 flex gap-2 px-0.5  rounded-full py-1  border border-[#424242] h-8 ">
              <button className="text-[14px] cursor-default leading-5 font-medium text-[#fff] bg-white bg-opacity-10 pl-2 pr-3 py-0.5 rounded-full flex items-center">
                Catalyse AI Disruption
              </button>
              <div className="flex flex-row items-center">
                <button className="text-[14px] leading-5 font-medium text-[#fff] pl-2 pr-3">
                  <Link href={`${getApplyRedirectUrl(session)}`}>
                    Apply Now
                  </Link>
                </button>
                <AiOutlineArrowRight className="text-[14px] leading-5 font-medium text-[#fff] mr-1" />
              </div>
            </div>
          </FadeIn>
          <FadeIn className="mt-3">
            <h1 className="text-[30px] sm:text-[72px] font-bold sm:leading-[90px] text-left text-[#FFFFFF]">
              Partner with AI Forge <br></br> to Create AI Solutions
            </h1>
          </FadeIn>
          <FadeIn className="text-white text-[20px] leading-[30px] font-normal text-left mt-8 w-full sm:w-2/3 text-left">
            We invite corporate partners and businesses to collaborate with our
            ambitious AI startups to solve complex challenges, drive innovation
            and gain a competitive edge in your industry. By partnering with us,
            you gain direct access to a pool of highly skilled AI founders who
            have been rigorously trained and are ready to tackle real-world
            problems.
          </FadeIn>
          <FadeIn className="flex gap-4 mt-12 flex-col sm:flex-row">
            <Link
              href={!session ? '/login' : '/i/profile'}
              className={buttonVariantsPartner({ size: '2xl' })}
            >
              Join Now
              <FiArrowUpRight className="text-[#18181B] text-xl md:text-2xl leading-7 ml-1 md:ml-3.5 " />
            </Link>

            <Link
              href="/team"
              className={cn(
                buttonVariantsPartner({
                  size: '2xl',
                  variant: 'secondary',
                }),
                'border-[#155EEF] bg-white/10 mt-3 sm:mt-0',
              )}
            >
              Our Team
              <FiArrowUpRight className="text-white text-xl md:text-2xl leading-7 ml-1 md:ml-3.5" />
            </Link>
          </FadeIn>
        </FadeInStagger>
        <div className="flex flex-col sm:flex-row items-center gap-2 sm:pl-[9.5rem] mt-12">
          <div className="flex items-center gap-6 min-w-[130px] text-lg font-[600] ">
            <div className="relative top-[-5px] ">Powered by: </div>
            <svg
              className="hidden sm:block"
              width="2"
              height="50"
              viewBox="0 0 2 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="2"
                height="50"
                fill="url(#paint0_radial_7533_51724)"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_7533_51724"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(1 25) rotate(90) scale(25 1)"
                >
                  <stop stop-color="#D9D9D9" stop-opacity="0.75" />
                  <stop offset="1" stop-color="white" stop-opacity="0.15" />
                </radialGradient>
              </defs>
            </svg>
          </div>
          <PoweredBy isPartner={true} />
        </div>
      </div>
    </section>
  )
}

const CollaborationOpportunities = () => {
  return (
    <FadeInStagger className="relative" faster>
      <img
        src="/images/home/mentors/partnerBg.webp"
        className="absolute right-0 top-0 z-0 opacity-[.10] "
      />
      <section className=" bg-black text-white">
        <div className="max-w-7xl mx-auto px-6">
          <FadeIn className="text-[40px] font-[500] mb-8">
            Three Collaboration Opportunities
          </FadeIn>

          <div className="grid gap-4 md:grid-cols-2">
            <FadeIn className="bg-black bg-opacity-[.3] border border-[#34373B] p-6 rounded-[16px] md:col-span-2 flex flex-col gap-4 sm:flex-row justify-between">
              <div className="flex flex-col justify-between">
                <div className="mr-3 mb-8 h-full">
                  <img src="/images/home/icons/s6.svg" />
                </div>{' '}
                <div>
                  <h3 className="text-[28px] font-[600]">
                    Corporate Innovation Challenges
                  </h3>
                  <p className="font-[600] text-lg mb-2 mt-4">
                    Custom Hackathons
                  </p>
                  <p className="text-[#BBC4D2]">
                    We charge corporates £10,000 to run the entire AI Innovation{' '}
                    <br></br>
                    Hackathon which includes the following:
                  </p>
                </div>
              </div>

              <ul className="text-[#BBC4D2] list-disc list-inside space-y-2">
                <li>
                  Discovery meeting in your HQ (1-3 days) to meet the relevant
                  people
                </li>
                <li>
                  Delivery of a report highlighting your specific issues that
                  could be solved using AI
                </li>
                <li>
                  Reaching out to AI entrepreneurs to stimulate interest in the
                  AI Innovation Hackathon
                </li>
                <li>
                  Hosting a pre-hackathon webinar to answer specific questions
                  from teams
                </li>
                <li>
                  Hosting an in-person 12 x hour event and creating c15 teams
                </li>
                <li>
                  Presentation of a minimum of 15 AI solutions tailored to your
                  exact company issues
                </li>
                <li>
                  You can then invite the top 3 winners to pitch to the
                  leadership team in HQ
                </li>
              </ul>
            </FadeIn>

            <FadeIn className="bg-black bg-opacity-[.3] border border-[#34373B] p-6 rounded-[16px]">
              <div className="flex flex-col justify-between">
                <div className="mr-3 mb-8 h-full">
                  <img src="/images/home/icons/s5.svg" />
                </div>{' '}
                <div>
                  <h3 className="text-xl font-[600] text-[28px] mb-4">
                    Pilot Programs and Proof of Concepts
                  </h3>
                  <p className="font-[600] text-lg mb-2">Test and Validate</p>
                  <p className="text-[#BBC4D2] mb-4">
                    Implement pilot projects with our startups to assess the
                    viability and impact of AI solutions in your operations.
                  </p>
                  <p className="font-[600] text-lg mb-2">Risk Mitigation</p>
                  <p className="text-[#BBC4D2]">
                    Evaluate new technologies in a controlled environment before
                    full-scale adoption.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn className="bg-black bg-opacity-[.3] border border-[#34373B] p-6 rounded-[16px]">
              <div className="flex flex-col">
                <div className="mr-3 mb-8 h-full">
                  <img src="/images/home/icons/s4.svg" />
                </div>{' '}
              </div>
              <div>
                <h3 className="text-xl font-[600] text-[28px] mb-4">
                  Strategic Partnerships
                </h3>
                <p className="font-[600] text-lg mb-2">
                  Long-Term Collaboration
                </p>
                <p className="text-[#BBC4D2] mb-4">
                  Establish partnerships for ongoing innovation and development.
                </p>
                <p className="font-[600] text-lg mb-2">Shared Success</p>
                <p className="text-[#BBC4D2] mb-4">
                  Align goals to achieve mutual benefits and drive industry
                  advancements.
                </p>
                <p className="font-[600] text-lg mb-2">Talent Acquisition</p>
                <p className="text-[#BBC4D2] mb-4">
                  Identify potential future hires among the brightest minds in
                  AI.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </section>
    </FadeInStagger>
  )
}

const BenefitsOfCollaboration = () => {
  return (
    <section className="py-12 bg-black text-white relative">
      <div className="max-w-7xl mx-auto text-center px-6 md:px-12">
        <FadeIn className="mb-4">
          <div className="bg-white bg-opacity-5 inline-flex gap-2 px-0.5  rounded-full py-1  border border-[#424242] h-8 ">
            <button className="text-[14px] cursor-default leading-5 font-medium text-[#fff] bg-white bg-opacity-10 pl-2 pr-3 py-0.5 rounded-full flex items-center">
              Catalyse AI Disruption
            </button>
          </div>
        </FadeIn>
        <FadeIn className="font-[500] text-[40px] mb-6">
          Benefits of Collaboration
        </FadeIn>
        <FadeIn className="text-[#D0D5DD] text-[20FadeInx] mb-12">
          Join our AI Ecosystem Partners program and collaborate with AI
          innovators. By nurturing startups in{' '}
          <br className="hidden sm:block"></br> their early stages, you
          contribute to the creation of revolutionary AI applications.
        </FadeIn>

        <div className="relative grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
          <div className="absolute inset-0 flex justify-center items-center">
            <div className="absolute w-48 h-48 rounded-full border border-[#414750] bg-black z-10  bg-opacity-[.5]"></div>
            <div className="absolute w-[9.5rem] h-[9.5rem] rounded-full border border-[#414750] bg-black z-10  "></div>

            <div className="w-full h-0.5 bg-[#34373B] bg-opacity-[.5] sm:bg-opacity-[1] absolute top-1/2 transform -translate-y-1/2"></div>
            <div className="h-full w-0.5 bg-[#34373B] bg-opacity-[.2] sm:bg-opacity-[1] absolute left-1/2 transform -translate-x-1/2"></div>

            <FadeIn className="flex items-center justify-center w-[109.85px] h-[109.85px] rounded-full z-10 border-2 border-white bg-black ">
              <svg
                width="49"
                height="36"
                viewBox="0 0 49 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.848862 35.1161L27.0334 0.984519C27.4749 0.441129 28.0353 0.169434 28.7145 0.169434H33.5541C33.9616 0.169434 34.1654 0.373205 34.1654 0.780747V35.218C34.1654 35.6256 33.9616 35.8293 33.5541 35.8293H28.7145C28.0353 35.8293 27.4749 35.5576 27.0334 35.0142L18.2203 23.5012L9.3563 35.0142C8.91479 35.5576 8.35442 35.8293 7.67519 35.8293H1.20546C1.03565 35.8293 0.899805 35.7614 0.79792 35.6256C0.696034 35.4558 0.713015 35.2859 0.848862 35.1161ZM22.4486 17.9994L27.6957 24.8257V11.1731L22.4486 17.9994Z"
                  fill="url(#paint0_linear_7533_51636)"
                />
                <path
                  d="M42.1316 0.169434H47.3787C47.8202 0.169434 48.0409 0.373205 48.0409 0.780747V35.218C48.0409 35.6256 47.8202 35.8293 47.3787 35.8293H42.1316C41.9618 35.8293 41.8089 35.7784 41.6731 35.6765C41.5712 35.5407 41.5202 35.3878 41.5202 35.218V0.780747C41.5202 0.610938 41.5712 0.475091 41.6731 0.373205C41.8089 0.237357 41.9618 0.169434 42.1316 0.169434Z"
                  fill="url(#paint1_linear_7533_51636)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_7533_51636"
                    x1="48.0409"
                    y1="-1.10538"
                    x2="48.0409"
                    y2="35.8293"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF5C00" />
                    <stop offset="0.314205" stop-color="#FFB700" />
                    <stop offset="1" stop-color="#FF2525" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_7533_51636"
                    x1="48.0409"
                    y1="-1.10538"
                    x2="48.0409"
                    y2="35.8293"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF5C00" />
                    <stop offset="0.314205" stop-color="#FFB700" />
                    <stop offset="1" stop-color="#FF2525" />
                  </linearGradient>
                </defs>
              </svg>
            </FadeIn>
          </div>

          <div className="flex flex-col items-center justify-center text-center p-2 sm:p-16 space-y-1">
            <FadeIn className="text-orange-500 text-4xl">
              <img src="/images/home/icons/s2.svg" />
            </FadeIn>{' '}
            <FadeIn className="text-[28px] font-[600] py-4 ">
              Access Elite AI Talent
            </FadeIn>
            <FadeIn className="text-[18px] font-[600] ">
              Work with the Best
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Our founders are top-tier talent and future category leaders in AI
              technologies.
            </FadeIn>
            <FadeIn className="text-[18px] font-[600]  pt-4">
              Innovative Solutions:
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Tap into cutting-edge AI technologies and methodologies to address
              your business needs.
            </FadeIn>
          </div>

          <div className="flex flex-col items-center justify-center text-center p-2 sm:p-16 space-y-1 pb-[258px] sm:pb-0 ">
            <FadeIn className="text-green-500 text-4xl">
              <img src="/images/home/icons/s3.svg" />
            </FadeIn>{' '}
            <FadeIn className="text-[28px] font-[600] py-4 ">
              Gain a Competitive Advantage
            </FadeIn>
            <FadeIn className="text-[18px] font-[600] ">Stay Ahead</FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Leverage AI solutions for transformative competitive advantages.
            </FadeIn>
            <FadeIn className="text-[18px] font-[600]  pt-4">
              Future-Proof Your Business:
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Integrate advanced AI technologies to build resilient, adaptive
              systems.
            </FadeIn>
          </div>

          <div className="flex flex-col items-center justify-center text-center p-2 sm:p-16 space-y-1">
            <FadeIn className="text-purple-500 text-4xl">
              <img src="/images/home/icons/s1.svg" />
            </FadeIn>{' '}
            <FadeIn className="text-[28px] font-[600] py-4 ">
              Speed Up Innovation
            </FadeIn>
            <FadeIn className="text-[18px] font-[600] ">Speed to Market</FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Collaborate with agile startups and reduce time to market for
              AI-powered solutions.
            </FadeIn>
            <FadeIn className="text-[18px] font-[600]  pt-4">
              Custom Solutions:
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Co-create AI accelerators tailored specifically to your
              organization’s challenges.
            </FadeIn>
          </div>

          <div className="flex flex-col items-center justify-center text-center p-2 sm:p-16 space-y-1">
            <FadeIn className="text-blue-500 text-4xl">
              <img src="/images/home/icons/s7.svg" />
            </FadeIn>{' '}
            <FadeIn className="text-[28px] font-[600] py-4 ">
              Boost Innovation Strategy
            </FadeIn>
            <FadeIn className="text-[18px] font-[600] ">
              Drive Transformation
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Implement AI solutions that transform your operations and drive
              strategic success.
            </FadeIn>
            <FadeIn className="text-[18px] font-[600] pt-4">
              Enhance Efficiency:
            </FadeIn>
            <FadeIn className="text-[#D0D5DD]">
              Optimize processes and reduce costs through intelligent automation
              and data-driven insights.
            </FadeIn>
          </div>
        </div>
      </div>
    </section>
  )
}
